'use strict';

var $ = require('jquery');

var b2bQuantity = {
    init: function () {
        $(document).on('change', '.quantity-multi-wrapper #quantityMultiInput', onQuantityChange);
        $(document).on('click', '.quantity-multi-wrapper .decrease-quantity', decreaseQuantity);
        $(document).on('click', '.quantity-multi-wrapper .increase-quantity', increaseQuantity);
    }
};

function onQuantityChange(e) {
    var $quantityMultiWrapper = $('.quantity-multi-wrapper');
    var $qtyInput = $quantityMultiWrapper.find('#quantityMultiInput');
    var $decreaseBtn = $quantityMultiWrapper.find('.decrease-quantity');
    var qtyValue = Number($qtyInput.val());

    if (qtyValue <= 1) {
        $decreaseBtn.attr('disabled', true);
        $qtyInput.val(1);
    } else {
        $decreaseBtn.attr('disabled', false);
    }
}

function decreaseQuantity(e) {
    var $quantityMultiWrapper = $('.quantity-multi-wrapper');
    var $qtyInput = $quantityMultiWrapper.find('#quantityMultiInput');
    var qtyValue = Number($qtyInput.val());

    var newQtyValue = qtyValue - 1;

    $qtyInput.val(newQtyValue.toFixed());
    onQuantityChange();
}

function increaseQuantity(e) {
    var $quantityMultiWrapper = $('.quantity-multi-wrapper');
    var $qtyInput = $quantityMultiWrapper.find('#quantityMultiInput');
    var qtyValue = Number($qtyInput.val());

    var newQtyValue = qtyValue + 1;

    $qtyInput.val(newQtyValue.toFixed());
    onQuantityChange();
}

module.exports = b2bQuantity;
